import moment from 'moment';
import { IKeywords, IInvolvedParty } from '../../../../common/sharedTypes';

// export class KeywordInfo {
//   constructor(
//     public agencyId: number,
//     public countyId: number,
//     public dateOfCrash: string,
//     public injuryStatus: string,
//     public nonMotoristIndicator: string,
//     public businessOwned: boolean,
//     public propertyDamageIndicator: string,
//     public reportTypeId: number,
//     public truckBusIndicator: string,
//     public workZoneIndicator: string,
//     public id?: string,
//     public modifiedById?: number,
//     public modifiedDate?: string,
//     public createdById?: number,
//     public createdDate?: string,
//     public involvedParties?: InvolvedPartyInfo[],
//     public businessName?: string
//   ) {}
// }

export class NDOTPaperReport {
  constructor(public crashKey: string, public pdf: string[]) {}
}
export class AgencyInfo {
  constructor(
    public id: number,
    public name: string,
    public description: string,
    public ori: string,
    public email: string,
    public vendor: string,
    public createdById: string,
    public createdDate: string,
    public modifiedById: string,
    public modifiedDate: string,
    public vendorId?: string
  ) {}
}

export class TypeInfo {
  constructor(
    public name: string,
    public description: string,
    public active: boolean,
    public version: number,
    public modifiedBy: number,
    public modifiedDate: Date,
    public id: number
  ) {}
}

export class NameInfo {
  constructor(
    public keywordsId: number,
    public firstName: string,
    public lastName: SVGAnimatedString
  ) {}
}

export class InvolvedPartyInfo {
  constructor(
    public keywordsId: number,
    public firstName: string,
    public lastName: string,
    public businessName: string
  ) {}
}

export class CountyInfo {
  constructor(
    public id: number,
    public name: string,
    public description: string,
    public active: boolean,
    public version: number,
    public fips: string,
    public modified_by?: number,
    public modified_date?: string
  ) {}
}

export class ReportTypesInfo {
  constructor(
    public id: number,
    public name: string,
    public description: string,
    public active: boolean,
    public version: number,
    public fips: string,
    public modified_by?: number,
    public modified_date?: string
  ) {}
}

export class ErrorInfo {
  constructor(
    public crashDate: string,
    public countySelection: string,
    public injurySelection: string,
    public agencySelection: string,
    public involvedPartyLength: string,
    public involvedPartyFirstName: string,
    public involvedPartyLastName: string,
    public involvedPartyBusinessName: string,
    public narrativeDiagram: string
  ) {}
}

export const initialErrorState: ErrorInfo = {
  crashDate: '',
  countySelection: '',
  injurySelection: '',
  agencySelection: '',
  involvedPartyLength: '',
  involvedPartyFirstName: '',
  involvedPartyLastName: '',
  involvedPartyBusinessName: '',
  narrativeDiagram: '',
};

export const initialInvolvedParty: IInvolvedParty = {
  id: 0,
  keywordsId: 0,
  firstName: '',
  lastName: '',
  businessName: '',
  businessOwned: false,
};

export const initialKeywordValues: IKeywords = {
  id: 0,
  reportTypeId: -1,
  countyId: null,
  dateOfCrash: '',
  agencyId: null,
  injuryStatus: '',
  involvedParties: [initialInvolvedParty],
  nonMotoristIndicator: null,
  workZoneIndicator: null,
  //businessOwned: false,
  //businessName: '',
  propertyDamageIndicator: '',
  truckBusIndicator: '',
  createdById: -1,
  createdDate: moment().format('YYYY/MM/DD'),
  modifiedById: -1,
  modifiedDate: moment().format('YYYY/MM/DD'),
};
